import { render, staticRenderFns } from "./successed.vue?vue&type=template&id=9ebddcc2&scoped=true&"
import script from "./successed.vue?vue&type=script&lang=js&"
export * from "./successed.vue?vue&type=script&lang=js&"
import style0 from "./successed.vue?vue&type=style&index=0&id=9ebddcc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebddcc2",
  null
  
)

export default component.exports